import { computed } from 'vue'

import { buildVelisRuntimeProtocol } from '../libs/velis-prompt'

/** Returns the stage control-token protocol for each model request. */
export function useAiriRuntimePrompt() {
  return computed(() => buildVelisRuntimeProtocol())
}
